import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 50px;
  width: 40%;
`;

const StyledLogo = styled.h1`
  font-size: ${({ theme }) => theme.font.size.s};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-family: Alex Brush, cursive;
  color: ${({ theme }) => theme.color.second};
  white-space: nowrap;
  margin: 0;
  padding: 0;
  ${({ theme }) => theme.mq.tablet} {
    font-size: ${({ theme }) => theme.font.size.m};
  }
  ${({ theme }) => theme.mq.desktop} {
    font-size: ${({ theme }) => theme.font.size.ml};
  }
`;

const Logo = () => (
  <StyledWrapper>
    <StyledLogo>Działki za Miastem</StyledLogo>
  </StyledWrapper>
);

export default Logo;
